<template>
  <div class="pod-tools-bar d-flex">
    <div class="mr-1" style="flex-grow: 1;">
      <v-btn
        :size="$vuetify.display.smAndDown ? 'small' : undefined"
        @click="goBack"
        color="secondaryButtons"
        elevation=0
        block
        :aria-label="$t('common.back')"
      >
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
    </div>

    <div v-if="!$isAdobeExtension() && !$isFCPExtension() && $canDownloadNodeAndPod()"
         class="mr-1"
         style="flex-grow: 4;"
    >
      <DownloadContextMenu>
        <template v-slot:activator="{ props }">
          <v-btn
            v-bind="props"
            :size="$vuetify.display.smAndDown ? 'small' : undefined"
            color="primary"
            elevation=0
            block
            data-cy="pod-tools-bar-downloadButton"
          >
            <v-icon>mdi-tray-arrow-down</v-icon>
            <span v-if="$vuetify.display.smAndUp">
              {{ $t('routes.pod.download') }}
            </span>
            <span v-if="$vuetify.display.smAndUp">
              <v-icon>mdi-menu-down</v-icon>
            </span>
          </v-btn>
        </template>
      </DownloadContextMenu>
    </div>

    <div v-if="canListAccesslinks || canControlAccesslinks"
         class="mr-1"
         style="flex-grow: 4;"
    >
      <ShareContextMenu :pod="pod">
        <template v-slot:activator="{ props }">
          <v-btn
            v-bind="props"
            :size="$vuetify.display.smAndDown ? 'small' : undefined"
            color="secondaryButtons"
            elevation=0
            block
            data-cy="pod-tools-bar-shareButton"
          >
            <v-icon>mdi-share</v-icon>
            <span v-if="$vuetify.display.smAndUp">
              {{ $t('routes.pod.share') }}
            </span>
            <span v-if="$vuetify.display.smAndUp">
              <v-icon>mdi-menu-down</v-icon>
            </span>
          </v-btn>
        </template>
      </ShareContextMenu>
    </div>

    <div class="mr-1" style="flex-grow: 4;">
      <FileContextMenu>
        <template v-slot:activator="{ props }">
          <v-btn
            v-bind="props"
            :size="$vuetify.display.smAndDown ? 'small' : undefined"
            color="secondaryButtons"
            elevation=0
            block
            data-cy="pod-tools-bar-fileButton"
          >
            <v-icon>mdi-file</v-icon>
            <span v-if="$vuetify.display.smAndUp">
            {{ $t('routes.pod.file') }}
          </span>
            <span v-if="$vuetify.display.smAndUp">
            <v-icon>mdi-menu-down</v-icon>
          </span>
          </v-btn>
        </template>
      </FileContextMenu>
    </div>

    <div class="" style="flex-grow: 4;">
      <ServicesContextMenu>
        <template v-slot:activator="{ props }">
          <v-btn
            v-bind="props"
            :size="$vuetify.display.smAndDown ? 'small' : undefined"
            color="secondaryButtons"
            elevation=0
            block
            data-cy="pod-tools-bar-servicesButton"
          >
            <v-icon>mdi-wrench</v-icon>
            <span v-if="$vuetify.display.smAndUp">
            {{ $t('routes.pod.services') }}
          </span>
            <span v-if="$vuetify.display.smAndUp">
            <v-icon>mdi-menu-down</v-icon>
          </span>
          </v-btn>
        </template>
      </ServicesContextMenu>
    </div>
  </div>
</template>

<script>
import { usePodStore } from '@/stores/PodStore.js';
import ServicesContextMenu from '../contextMenus/ServicesContextMenu.vue'
import DownloadContextMenu from '../contextMenus/DownloadContextMenu.vue'
import ShareContextMenu from '../contextMenus/ShareContextMenu.vue'
import FileContextMenu from '../contextMenus/FileContextMenu.vue'

export default {
  name: "PodToolsBar",
  components: {
    ServicesContextMenu,
    DownloadContextMenu,
    ShareContextMenu,
    FileContextMenu,
  },
  methods: {
    goBack: function() {
      if (window.history.state.back && window.history.state.back.startsWith('/search')) {
        // Only navigate back in history if we were on the search page
        this.$router.back();
      } else if (this.pod && this.pod.nodeid) {
        this.$router.push('/node/' + this.pod.nodeid);
      } else {
        this.$router.push('/');
      }
    },
  },
  computed: {
    pod: function() {
      const podStore = usePodStore();
      return podStore.getViewPod;
    },
    canListAccesslinks() {
      return  this.$canListNodeAndPod() &&
              this.$canListShareLinks();
    },
    canControlAccesslinks() {
      return  this.$canListNodeAndPod() &&
              this.$canControlNodeAndPod() &&
              this.$canListShareLinks() &&
              this.$canControlShareLinks();
    },
  }
}
</script>

<style lang="scss" scoped>
.pod-tools-bar {
  position: sticky;
  top: 0;
  padding: 12px 0 8px 0;
  z-index: 4;
  overflow: auto;
}


:global(.v-theme--dark .pod-tools-bar) {
  background-color: #14171b;
}

:global(.v-theme--light .pod-tools-bar) {
  background-color: #e6ecf1;
}
</style>
